/* eslint-disable jsx-a11y/role-supports-aria-props */
import ShopFnbFacilitySearchModeButton from '@/components/common/shop-fnb-facility/buttons/search-mode';
import { SHOP_SEARCH_MODE } from '@/enums/shop';
import { useOrientation } from '@/hooks';
import useBaseSize from '@/hooks/useBaseSize';
import { getHSize } from '@/utils/size';
import { TrackingService } from '@/services/analytics/TrackingService';
import { useShopStore } from '@/stores';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface ShopSearchControlProps {
    currentMode: SHOP_SEARCH_MODE;
    isVerticalFullscreen?: boolean;
}

const ShopSearchControl = ({ currentMode, isVerticalFullscreen = false }: ShopSearchControlProps) => {
    const { t } = useTranslation();
    const { isHorizontal } = useOrientation();
    const { baseHeight } = useBaseSize();
    const setCurrentMode = useShopStore((state) => state.setCurrentMode);
    const updateShopContents = useShopStore((state) => state.updateShopContents);
    const setSearchText = useShopStore((state) => state.setSearchText);
    const resetFilters = useShopStore((state) => state.resetFilters);

    const handleChangeMode = (mode: SHOP_SEARCH_MODE) => {
        TrackingService.clearSearchKeyword();
        resetFilters();
        setCurrentMode(mode);
        updateShopContents(mode);
    };

    return (
        <div
            className={clsx('flex w-full items-center justify-center', isVerticalFullscreen ? 'flex-row' : 'flex-col')}
            style={{ gap: isVerticalFullscreen ? getHSize(12, baseHeight) : isHorizontal ? getHSize(8, baseHeight) : getHSize(12, baseHeight) }}
            data-region-nav
        >
            <ShopFnbFacilitySearchModeButton
                tabIndex={6}
                fullWidth
                role="tab"
                type="button"
                aria-label={t('shop.search.tts.control_buttons.search_by_text')}
                title={t('shop.search.text.control_buttons.search_by_text')}
                onClick={() => {
                    setSearchText('');
                    handleChangeMode(SHOP_SEARCH_MODE.SEARCH_BY_TEXT);
                }}
                aria-checked={currentMode === SHOP_SEARCH_MODE.SEARCH_BY_TEXT}
                data-interactive
            />
            <ShopFnbFacilitySearchModeButton
                tabIndex={7}
                fullWidth
                role="tab"
                type="button"
                aria-label={t('shop.search.tts.control_buttons.search_by_floor')}
                title={t('shop.search.text.control_buttons.search_by_floor')}
                onClick={() => handleChangeMode(SHOP_SEARCH_MODE.SEARCH_BY_FLOOR)}
                aria-checked={currentMode === SHOP_SEARCH_MODE.SEARCH_BY_FLOOR}
                data-interactive
            />
            <ShopFnbFacilitySearchModeButton
                tabIndex={8}
                fullWidth
                role="tab"
                type="button"
                aria-label={t('shop.search.tts.control_buttons.search_by_category')}
                title={t('shop.search.text.control_buttons.search_by_category')}
                onClick={() => handleChangeMode(SHOP_SEARCH_MODE.SEARCH_BY_CATEGORY)}
                aria-checked={currentMode === SHOP_SEARCH_MODE.SEARCH_BY_CATEGORY}
                data-interactive
            />
        </div>
    );
};

export default ShopSearchControl;
